import { _lang, getCurrentSystem } from '@umu/ukit-lang';

//平台勋章
export const MEDAL_TYPE_USER_LEVEL_CHANGE = 100; //用户成长等级变化（成长之路）
export const MEDAL_TYPE_INVITING_USERS = 101;  //邀请用户数（一呼百应）
export const MEDAL_TYPE_CONSUMER_MONEY = 102;  //消费金额，报名/赞赏（人生赢家）
//老师身份获得的勋章
export const MEDAL_TYPE_TEACHER_AFFECT_USER_NUM = 200;  //影响学员人数（名师之路）
export const MEDAL_TYPE_TEACHER_AFFECT_USER_TIMES = 201;  //影响学员人次（实力的证明）
export const MEDAL_TYPE_TEACHER_CREATE_VALID_SESSION = 202;  //创建有效小节数（聚沙成塔）
export const MEDAL_TYPE_TEACHER_SESSION_STAR = 203;  //小节好评数（众星捧月）
export const MEDAL_TYPE_TEACHER_SESSION_LIKE = 204;  //小节获赞数（赞不绝口）
//学生身份获得的勋章
export const MEDAL_TYPE_STUDENT_LIKE = 300;  //学生点赞数（神助攻）
export const MEDAL_TYPE_STUDENT_COMMENT = 301;  //学生发言数（言之有物）
export const MEDAL_TYPE_STUDENT_ONLINE_TIME = 302;  //学生在线时长（念念不忘）
export const MEDAL_TYPE_STUDENT_GET_LIKE = 303;  //学生发言获得的点赞数（人见人爱）

export const getStaticDomain = () => {
    const currentSystem = getCurrentSystem();
    if (currentSystem === 'EN') {
        return 'https://statics00.umustatic.com';
    } else if (currentSystem === 'JP') {
        return 'https://statics22.umustatic.com';
    } else if (currentSystem === 'TW') {
        return 'https://statics11.umustatic.com';
    }

    return 'https://statics-umu-cn.umucdn.cn';
};

export const MEDAL_SIZE = {
    LARGE: 'L',
    SMALL: 'S',
};

function getBaseUrl() {
    let url = getStaticDomain();
    url += '/cdn/image';

    // 目录
    let dir = '/achievement';
    if (!_lang('CN')) {
        dir = dir + '/global';
    }

    return url + dir;
}

export function getMedalIcon(type: string, rank: string, size = MEDAL_SIZE.LARGE) {
    // 默认返回大尺寸
    size = size || MEDAL_SIZE.LARGE;

    if (!type || !rank) {
        return;
    }

    let ret = '';
    ret = '/medal_' + size + '/' + type + '_' + rank;
    ret = getBaseUrl() + ret + '.png';

    // 勋章图的版本号。如果有更新，需要修改版本号清缓存
    const MEDAL_ICON_VERSION = '3';

    // 添加版本信息
    if (MEDAL_ICON_VERSION) {
        ret += '?' + MEDAL_ICON_VERSION;
    }
    return ret;
}
